module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/user-management/user-management.component.css
// module id = 1022
// module chunks = 1